import { render, staticRenderFns } from "./About.vue?vue&type=template&id=2eba5250&scoped=true"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=2eba5250&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba5250",
  null
  
)

export default component.exports